import React, { useState } from 'react';
import { perfilAutos, MATRIZ_AUTOS } from '../engine/matrizAutos';

// Cálculo del riesgo (sesión #6): solo lo ve el asesor, en el panel del caso; el cliente no ve puntajes
// para que no aprenda a acomodar las respuestas
export const PerfilRiesgoAutos = ({ answers, abiertoInicial = false }) => {
  const [abierto, setAbierto] = useState(abiertoInicial);
  const p = perfilAutos(answers);
  if (!p.completo) return null;
  const pct = (x) => `${Math.round(x * 100)} %`;
  return (
    <section className={`pra ${p.nivel}`} data-testid="perfil-riesgo-autos">
      <button type="button" className="pra-head" onClick={() => setAbierto((a) => !a)} aria-expanded={abierto} data-testid="pra-toggle">
        <span className="pra-k">Cálculo del riesgo · solo asesor</span>
        <span className="pra-score" data-testid="pra-score">
          <b>{p.score}</b>/100 · Riesgo <b data-testid="pra-nivel">{p.etiqueta.toLowerCase()}</b>
        </span>
        <span className="pra-bar" aria-hidden="true"><i style={{ width: `${p.score}%` }} /></span>
      </button>
      {abierto ? (
        <div className="pra-body">
          {p.bloques.map((b) => (
            <div key={b.id} className="pra-bloque" data-testid={`pra-bloque-${b.id}`}>
              <div className="pra-bloque-t">
                <span>{b.nombre}</span>
                <span>{`promedio ${Math.round(b.promedio)} × ${pct(b.peso)} = `}<b>{b.aporte.toFixed(1)}</b></span>
              </div>
              <ul>
                {b.vars.map((v) => (
                  <li key={v.id}>
                    <span>{v.label}: {v.resp}</span>
                    <b className={v.pts >= 70 ? 'alto' : v.pts >= 40 ? 'medio' : 'bajo'}>{v.pts}</b>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <p className="pra-formula" data-testid="pra-formula">
            {`Puntaje = conductor ${p.bloques[0].aporte.toFixed(1)} + uso y entorno ${p.bloques[1].aporte.toFixed(1)} = ${p.score}. Bajo hasta 30 · medio 31 a 60 · alto 61 a 100.`}
          </p>
          {p.flags.length ? (
            <p className="pra-flag" data-testid="pra-flags">
              {`Alerta que lo pasa a riesgo alto sin importar el puntaje: ${p.flags.map((f) => f.texto.charAt(0).toLowerCase() + f.texto.slice(1)).join('; ')}.`}
            </p>
          ) : null}
          <div className="pra-sus" data-testid="pra-suscripcion">
            <span className="pra-sus-t">Lo que esto cambia en la póliza</span>
            <ul>
              <li><b>Aceptación:</b> {p.sus.aceptacion}</li>
              <li><b>Cobertura:</b> {p.sus.cobertura}</li>
              <li><b>Responsabilidad civil:</b> {p.sus.rc_texto}</li>
              <li><b>Deducible daños parciales:</b> {p.sus.ded_parcial} · <b>hurto:</b> {p.sus.ded_hurto}</li>
              {p.sus.ded_regla ? <li className="pra-ded-regla">{p.sus.ded_regla}</li> : null}
              <li><b>Vehículo de reemplazo:</b> {p.sus.reemplazo}</li>
              {p.sus.extra ? <li>{p.sus.extra}</li> : null}
            </ul>
          </div>
          <p className="pra-rotulo">{MATRIZ_AUTOS.rotulo}</p>
        </div>
      ) : null}
    </section>
  );
};
